import { h, JSX } from 'preact'
import * as style from './style.css'

interface Props {
    color?: string
    width?: number
}

export default function Spinner({ color = '#fff', width = 8 }: Props): JSX.Element {
    return (
        <div className={style.ldsRing}>
            {[0, 1, 2, 3].map((key) => (
                <div
                    key={key}
                    style={{
                        borderWidth: `${width}px`,
                        borderTopColor: color,
                    }}
                />
            ))}
        </div>
    )
}
